export const HierarchyUserStatus = {
    Pending: 1,
    Assigned: 2,
    Unassigned: 3
};
